import styled from "styled-components";

export const NavbarContainer = styled.div`
    height: 10rem;
    background-color: #fff;
    padding: 0 2rem;
    display: flex;
    align-items: center;
    box-shadow: 3px 0px 20px rgba(0, 0, 0, 0.04);
`;

export const FormContainer = styled.form`
@media (max-width: 730px) {
    display: none;
}
`;

export const IconContainer = styled.div`
    display: none;
    color:  ${({ theme }) => theme && theme.colors?.darkBlue};

    @media (max-width: 1167px) {
        display: flex;
        margin-right: 5rem;
        
        svg {
            width: 24px;
            height: 24px;
        }
    }
`;
export const ActionsContainer = styled.div`
    display: flex;
    align-items: center;
    flex: 1;
`;
export const NotificationIconContainer = styled.div`
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    color:  #213F7D;
    margin: 0px 24px;
`;

export const StyledSearchInputContainer = styled.div`
    display: flex;
    

    .search-btn-icon {
        background-color: ${({ theme }) => theme.colors?.green};
        color: ${({ theme }) => theme.colors?.white};
        display: flex;
        align-items: center;
        justify-content: center;
        width: 5.8rem;
        margin-left: -2px;
        z-index: 1;
        border-radius: 0 8px 8px 0;
        cursor: pointer;
        align-self: end;
        height: 5rem;
    }
`;
export const StyledOtherActions = styled.div`
    display: flex;
    align-items: center;
    margin-left: auto;

    .docs-text {
        font-weight: 400;
        font-size: 1.6rem;
        text-decoration: underline;
        text-transform: capitalize;
        color: #213F7D;

        @media (max-width: 410px) {
            display: none;
        }
    }
`;
export const StyledAvatarContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 1rem;
    color: #213F7D;

    .avatar-name {
        font-weight: 500;
        font-size: 1.6rem;        
    }
`;
export const StyledAvatar = styled.div`
    width: 4.8rem;
    height: 4.8rem;
    background-color: red;
    border-radius: 50%;
`;